import { render, staticRenderFns } from "./dischargeFac.vue?vue&type=template&id=3a96806c"
import script from "./dischargeFac.vue?vue&type=script&lang=js"
export * from "./dischargeFac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a96806c')) {
      api.createRecord('3a96806c', component.options)
    } else {
      api.reload('3a96806c', component.options)
    }
    module.hot.accept("./dischargeFac.vue?vue&type=template&id=3a96806c", function () {
      api.rerender('3a96806c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/gas/baseinfo/dischargeFac.vue"
export default component.exports